// extracted by mini-css-extract-plugin
module.exports = {"white100":"#fff","primary":"#400099","primaryD10":"#2b0066","IconWrapper":"medkit__Icon__IconWrapper","Icon":"medkit__Icon__Icon"};